import React from 'react';
import { InputBaseComponentProps } from '@material-ui/core/InputBase';
import { TextFieldProps } from '@material-ui/core';
import MaskInput from 'react-text-mask';
import Input from '@components/common/Input';

interface CustomMaskedInputProps {
  inputRef: (ref: HTMLInputElement | null) => void;
  mask: string;
  showMask?: boolean;
  placeholderChar?: string;
  guide?: boolean;
}

const CustomMaskedInput: React.FunctionComponent<CustomMaskedInputProps> = ({
  inputRef,
  showMask = false,
  guide = false,
  placeholderChar = '\u2000',
  ...other
}) => {
  const mask = other?.mask?.split('').map((key) => {
    if (key === '9') return /\d/;
    return key;
  });

  return (
    <MaskInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? (ref.inputElement as HTMLInputElement) : null);
      }}
      mask={mask}
      showMask={showMask}
      placeholderChar={placeholderChar}
      guide={guide}
    />
  );
};

const MaskedInput: React.FC<TextFieldProps> = ({
  value,
  onChange,
  onBlur,
  label,
  InputProps,
  ...props
}) => {
  return (
    <Input
      size="small"
      variant="outlined"
      name="phone"
      data-testid="maskedInput"
      value={value}
      label={label}
      onChange={onChange}
      onBlur={onBlur}
      InputProps={{
        ...InputProps,
        inputComponent: CustomMaskedInput as React.FC<InputBaseComponentProps>,
      }}
      {...props}
    />
  );
};

export default MaskedInput;
